export default "/stream.76afb0424ff4a8a6c009f1b316baedd1.svg";